if (!customElements.get('snug-pack-sizes')) {
  let Events = null;
  try { Events = await import('@shopify/events'); } catch (error) { Events = null; }

  class SnugPackSizes extends HTMLElement {
    connectedCallback() {
      this.lastSizes = [];
      this.onChange = (event) => {
        if (event.target.matches('.sbs__radio')) this.sync(true);
        else if (event.target.matches('.sbs__select')) this.remember();
      };
      this.onClick = (event) => { if (event.target.closest('[data-sbs-add]')) this.add(); };
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.sync(false);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
    }
    get option() {
      const radio = this.querySelector('.sbs__radio:checked');
      return radio ? radio.closest('.sbs__option') : null;
    }
    selects(option = this.option) {
      return option ? Array.from(option.querySelectorAll('.sbs__select')) : [];
    }
    remember() { this.lastSizes = this.selects().map((select) => select.value); }
    sync(carry) {
      const current = this.option;
      this.querySelectorAll('.sbs__option').forEach((option) => {
        const on = option === current;
        option.classList.toggle('is-selected', on);
        const panel = option.querySelector('.sbs__sizes');
        if (panel) panel.hidden = !on;
      });
      if (carry && this.lastSizes.length) {
        this.selects().forEach((select, index) => {
          const value = this.lastSizes[Math.min(index, this.lastSizes.length - 1)];
          const match = Array.from(select.options).find((item) => item.value === value && !item.disabled);
          if (match) select.value = value;
        });
      }
      this.remember();
      const total = this.querySelector('[data-sbs-total]');
      if (total && current) total.textContent = current.dataset.total;
    }
    async refreshCart() {
      const cartItems = document.querySelector('cart-items-component');
      if (cartItems) {
        await customElements.whenDefined('cart-items-component');
        if (typeof cartItems.fetchCartData === 'function') return cartItems.fetchCartData();
      }
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      return response.json();
    }
    async add() {
      const option = this.option;
      const button = this.querySelector('[data-sbs-add]');
      if (!option || !button || button.disabled) return;
      const qty = parseInt(option.dataset.qty, 10) || 1;
      const ids = this.selects(option).map((select) => select.value);
      while (ids.length < qty) ids.push(this.dataset.variantId);
      const counts = new Map();
      ids.forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
      const items = Array.from(counts, ([id, quantity]) => ({ id: Number(id), quantity }));
      const sections = Array.from(document.querySelectorAll('cart-items-component')).map((el) => el.dataset.sectionId).filter(Boolean);
      const error = this.querySelector('[data-sbs-error]');
      if (error) { error.hidden = true; error.textContent = ''; }
      button.disabled = true;
      let deferred = null;
      if (Events && Events.CartLinesUpdateEvent) {
        deferred = Events.CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(new Events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
          promise: deferred.promise,
        }));
      }
      const finish = (cart, data, didError) => deferred.resolve({
        cart: Events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'snug-pack-sizes', sourceId: 'snug-pack-sizes', itemCount: qty, productId: this.dataset.productId, sections: data ? data.sections : undefined, didError },
      });
      try {
        const url = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: sections.join(',') }),
        });
        const data = await response.json();
        if (data.status) throw new Error(data.description || data.message || 'Could not add to cart.');
        const cart = await this.refreshCart();
        if (!deferred) {
          window.location.href = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
          return;
        }
        finish(cart, data, false);
        const label = this.querySelector('[data-sbs-label]');
        if (label && button.dataset.addedLabel) {
          const original = label.textContent;
          label.textContent = button.dataset.addedLabel;
          setTimeout(() => { label.textContent = original; }, 2000);
        }
      } catch (err) {
        if (error) { error.textContent = err && err.message ? err.message : 'Could not add to cart.'; error.hidden = false; }
        if (deferred) this.refreshCart().then((cart) => finish(cart, null, true)).catch((rejection) => deferred.reject(rejection));
      } finally {
        button.disabled = false;
      }
    }
  }
  customElements.define('snug-pack-sizes', SnugPackSizes);
}